import React, {memo} from "react";
import {Icon} from "@material-ui/core";
import {DEFAULT_AVATAR, DEFAULT_WIDGET_PICTURE} from "../../../appConfig";
import LightTooltip from "../../../components/LigthTooltip";

const RegistrationForServiceHeader = ({company_name, picture_link, avatar_link, isAvatarHidden, page, step, setStep}) => (
    <div className="registration-for-service__head head">
        <img src={picture_link || DEFAULT_WIDGET_PICTURE} alt="" className="head__img"/>
        <div className="head__content">
            <div className="head__content__wrapper">
                <h4 className="head__title">
                    {page === 1 ?
                        step === 1 ? 'Выбор услуги' :
                        step === 2 ? 'Выбор даты' :
                        step === 3 ? 'Выбор времени' :
                        'Оформление' :
                    page === 2 ? 'О нас' :
                    page === 3 ? 'Профиль' : 'Мои записи'
                    }
                </h4>
                {page === 1 && step > 1 && step !== 5 &&
                        <button className="head__back-btn" onClick={() => setStep(step - 1)}>
                            <Icon>arrow_back_ios</Icon>
                            Назад
                        </button>
                }
            </div>
            {!isAvatarHidden && <img src={avatar_link || DEFAULT_AVATAR} className="head__avatar" alt=""/>}
            <div className="head__info">
                <div className="head__text-block">
                    <LightTooltip title={company_name}>
                        <h3 className="head__name">{company_name}</h3>
                    </LightTooltip>
                    <span className="head__label">работает на zline.me</span>
                </div>
            </div>
        </div>
    </div>
);

export default memo(RegistrationForServiceHeader);